export const SIGN_OUT = 'signOut';
export const CREATE_TEAM = 'createTeam';
export const ADD_TEAM_MEMBER = 'addTeamMember';
export const FORGOT_PASSWORD = 'forgotPassword';
export const JOIN_MATCH = 'joinMatch';
export const MANAGE_SQUAD = 'manageSquad';
export const SEAT_DRAW = 'seatDraw';
